function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "3-level4_svg__b",
  x1: 54.23,
  y1: 98.47,
  x2: 24.43,
  y2: -13.6,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#80e8bb"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "3-level4_svg__a",
  x1: 16.56,
  y1: -8.61,
  x2: 40.44,
  y2: 42.67,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#007763"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "3-level4_svg__c",
  x1: 56.61,
  y1: 82.31,
  x2: 34.19,
  y2: 28.23,
  xlinkHref: "#3-level4_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#3-level4_svg__b)",
  d: "M69.52 42.99L76 37.43l-6.48-5.56 4.2-7.44-8-3L67.11 13l-8.54-.09-1.56-8.39-8.06 2.83L44.6 0 38 5.43 31.4 0l-4.35 7.35L19 4.52l-1.57 8.39-8.54.09 1.39 8.43-8 3 4.2 7.44L0 37.43l6.48 5.56-4.2 7.44 8 3-1.39 8.43 8.54.08 1.57 8.4 8.05-2.83 4.35 7.35 6.6-5.43 6.6 5.43 4.35-7.35 8.06 2.83 1.56-8.4 8.54-.08-1.39-8.43 8-3-4.2-7.44z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38 14.78a22.65 22.65 0 1022.65 22.65A22.65 22.65 0 0038 14.78z",
  fill: "url(#3-level4_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38 19.41a18 18 0 1018 18 18 18 0 00-18-18z",
  fill: "url(#3-level4_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.5 37.4l4.5-5.84h3.1v6.3h1.71V40h-1.76v2.23h-2.6V40h-5zm5-3.07l-2.69 3.53h2.69z",
  fill: "#fff"
}));

function Svg3Level4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 76 74.86"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNzYgNzQuODYiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iYiIgeDE9IjU0LjIzIiB5MT0iOTguNDciIHgyPSIyNC40MyIgeTI9Ii0xMy42IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjMjNjMzg2Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODBlOGJiIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIxNi41NiIgeTE9Ii04LjYxIiB4Mj0iNDAuNDQiIHkyPSI0Mi42NyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzAwNzc2MyIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzIzYzM4NiIvPjwvbGluZWFyR3JhZGllbnQ+PGxpbmVhckdyYWRpZW50IGlkPSJjIiB4MT0iNTYuNjEiIHkxPSI4Mi4zMSIgeDI9IjM0LjE5IiB5Mj0iMjguMjMiIHhsaW5rOmhyZWY9IiNhIi8+PC9kZWZzPjxnIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PHBhdGggZmlsbD0idXJsKCNiKSIgZD0iTTY5LjUyIDQyLjk5TDc2IDM3LjQzbC02LjQ4LTUuNTYgNC4yLTcuNDQtOC0zTDY3LjExIDEzbC04LjU0LS4wOS0xLjU2LTguMzktOC4wNiAyLjgzTDQ0LjYgMCAzOCA1LjQzIDMxLjQgMGwtNC4zNSA3LjM1TDE5IDQuNTJsLTEuNTcgOC4zOS04LjU0LjA5IDEuMzkgOC40My04IDMgNC4yIDcuNDRMMCAzNy40M2w2LjQ4IDUuNTYtNC4yIDcuNDQgOCAzLTEuMzkgOC40MyA4LjU0LjA4IDEuNTcgOC40IDguMDUtMi44MyA0LjM1IDcuMzUgNi42LTUuNDMgNi42IDUuNDMgNC4zNS03LjM1IDguMDYgMi44MyAxLjU2LTguNCA4LjU0LS4wOC0xLjM5LTguNDMgOC0zLTQuMi03LjQ0eiIvPjxwYXRoIGQ9Ik0zOCAxNC43OGEyMi42NSAyMi42NSAwIDEwMjIuNjUgMjIuNjVBMjIuNjUgMjIuNjUgMCAwMDM4IDE0Ljc4eiIgZmlsbD0idXJsKCNhKSIvPjxwYXRoIGQ9Ik0zOCAxOS40MWExOCAxOCAwIDEwMTggMTggMTggMTggMCAwMC0xOC0xOHoiIGZpbGw9InVybCgjYykiLz48cGF0aCBkPSJNMzMuNSAzNy40bDQuNS01Ljg0aDMuMXY2LjNoMS43MVY0MGgtMS43NnYyLjIzaC0yLjZWNDBoLTV6bTUtMy4wN2wtMi42OSAzLjUzaDIuNjl6IiBmaWxsPSIjZmZmIi8+PC9nPjwvc3ZnPg==";
export { Svg3Level4 as ReactComponent };